module.exports = "<app-generic-form-page></app-generic-form-page>"


//////////////////
// WEBPACK FOOTER
// ./src/app/customer-overview/customer-edit/customer-edit.component.html
// module id = ./src/app/customer-overview/customer-edit/customer-edit.component.html
// module chunks = main